module.exports = __webpack_public_path__ + "img/prize-05.dd531e0d.png";